import type { ChangelogEntry } from "../types";

/**
 * VIB-2724. Søk og filter på hjelp-sidene.
 *
 * Ingen rollekrav og ingen feature-flagg: hjelp-senteret er åpent for alle
 * roller, også eksterne, og endringen er ren frontend på innhold alle ser.
 */
export const HJELP_SOK_2026_10: ChangelogEntry = {
  id: "2026-10-02-hjelp-sok",
  date: "2026-10-02",
  title: "Søk og filter i Hjelp",
  summary:
    "Både endringsloggen og hjelp-oversikten har fått søkefelt og filterknapper, så du slipper å rulle gjennom alt for å finne én ting.",
  sections: [
    {
      heading: "Hjelp",
      items: [
        {
          title: "Søk i «Nytt i Revehiet»",
          kind: "nytt",
          body: "Skriv i feltet over lista, og den snevres inn mens du skriver. Treffer søket tittelen på en oppføring, vises hele oppføringen, slik at du ser alt som kom i den runden og ikke bare de punktene som gjentar ordet du søkte på. Esc tømmer feltet.",
        },
        {
          title: "Hvert punkt er merket Nytt, Forbedret eller Rettet",
          kind: "nytt",
          body: "Merket står foran tittelen, og knappene over lista slår dem av og på. Leter du bare etter hva som er rettet, trykker du «Rettet». Du kan ha flere på samtidig, og er ingen valgt vises alt.",
        },
        {
          title: "Søk og målgruppefilter på hjelp-oversikten",
          kind: "nytt",
          body: "Søket leter i hele veiledningen, ikke bare i titlene, så du finner temaet som forklarer faktureringsgrad selv om ordet ikke står i overskriften. Knappene begrenser til én eller flere målgrupper, for eksempel bare det som gjelder produksjonsledere.",
        },
        {
          title: "Tom-tilstand med nullstilling",
          kind: "nytt",
          body: "Gir søket ingen treff, står det tydelig, med en knapp som fjerner både søk og filter. Da blir du ikke sittende og tro at innholdet er borte.",
        },
      ],
    },
  ],
};
